import { DatePicker as AntDatePicker } from 'antd';
import type { DatePickerProps } from 'antd';
import iconCalendar from 'app/assets/images/calendar.svg';

export const DatePicker = ({ format = 'MM / DD / YYYY', ...props }: DatePickerProps) => {
  return <AntDatePicker suffixIcon={<img src={iconCalendar} alt="calendar" />} format={format} {...props} />;
};
